import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import { localize } from 'helpers/translator'
import mpActions from 'redux/actions/matching_pairs_ct_actions'

const PairDeleteConfirm = props => (
	<Confirm
		btOne={localize('global_cancel')}
		btTwo={localize('global_delete')}
		alertTitle={localize('matching_pairs_ct_delete_confirmation_title')}
		alertMessage={localize('matching_pairs_ct_delete_confirmation_information')}
		actionButtonType={1}
		actionOne={() => {
			props.actions.deleteReject()
		}}
		actionTwo={() => props.actions.deleteConfirm(props.pairId)}
		closeAction={() => props.actions.deleteReject()}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		deleteReject: mpActions.pairDeleteReject,
		deleteConfirm: mpActions.pairDeleteConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PairDeleteConfirm)
